/* eslint-disable */
import React, { useState, useMemo, useRef, useCallback } from 'react'
import classnames from 'classnames'
import dayjs from 'dayjs'
import ceil from 'lodash/ceil'
import noop from 'lodash/noop'
import isNull from 'lodash/isNull'
import isUndefined from 'lodash/isUndefined'
import { isServer } from '@/utils'
import IconSvg from '@/components/IconSvg'
// import { ImageLazyLoad as ReactLazyLoad } from '@/components'
import CBVideo from '@/components/CBVideo'
import styles from './index.module.less'

interface Item {
  // id: Number;
  status?: number
  type?: number | string
  fileStatus?: number
  previewUrl?: string
  url?: string
  times?: number | string
}

export interface MappingItem {
  status?: string
  type?: string
  fileStatus?: string
  previewUrl?: string
  url?: string
  times?: string
}

interface MediaBoxProps {
  classNameWrap?: string
  // 是否显示为正方形
  square?: boolean
  scrollContainer?: string
  item: Item
  // 全屏预览回调
  handlePreview?: Function
  // 是否显示播放icon
  playIconVisible?: boolean
  // 鼠标悬浮是否自动播放
  hoverAutoDisplay?: boolean
  // 字段映射
  mappingItem?: MappingItem
  // 播放锚点, 如果hoverAutoDisplay开启，鼠标移动到锚点位置才会播放
  playAnchor?: () => React.ReactElement
  // 是否显示内联背景
  showBgImageUrl?: boolean
  // 是否显示背景图
  showBgImage?: boolean
  // 悬浮播放回调
  hoverPlayCallback?: () => void
  translateTxt?: (v: string) => any
}

const setHeight = (dom: any) => {
  // 获取dom宽度
  if (dom) {
    dom.style.height = `${dom.clientWidth}px`
    dom.style.lineHeight = `${dom.clientWidth}px`
  }
}
// downloadUrl: "http://media.meetsocial.cn/video%2Fvideo_9b9e31d39aa66f97d55762ea58993725.mp4"
// fileName: "462657971686236.mp4"
// orignalUrl: "http://media.meetsocial.cn/video%2Fvideo_9b9e31d39aa66f97d55762ea58993725.mp4"
// previewUrl: "http://media.meetsocial.cn/video%2Fvideo_9b9e31d39aa66f97d55762ea58993725.mp4?x-oss-process=video/snapshot,t_1000,f_jpg,w_600,h_600,m_fast"
// times: "27.71"
// type: "video"
const DefultMappingItem = {
  status: 'status',
  type: 'type',
  fileStatus: 'fileStatus',
  previewUrl: 'previewUrl',
  url: 'url',
  times: 'times',
}

const MediaBox = React.memo((props: MediaBoxProps) => {
  const {
    classNameWrap = '',
    item,
    handlePreview = () => {},
    scrollContainer,
    square = true,
    playIconVisible = true,
    hoverAutoDisplay = false,
    mappingItem,
    playAnchor = () => null,
    showBgImageUrl = true,
    showBgImage = true,
    hoverPlayCallback,
    translateTxt,
  } = props

  const [loaded, setLoaded] = React.useState(false)
  const maskRef: any = React.useRef()

  const formatItem: Item = useMemo(() => {
    const formatMappingItem = Object.assign({}, DefultMappingItem, mappingItem)
    const temp: Item = Object.keys(formatMappingItem).reduce((pre, key) => {
      return {
        ...pre,
        // @ts-ignore
        [key]: item[formatMappingItem[key]],
      }
    }, {})
    /* 文件类型type 1图片 2视频 */
    // temp.type = (temp.type === 'image' || temp.type === 1) ? 1 : (temp.type === 'video' || temp.type === 2) ? 2 : 2;
    switch (temp.type) {
      case 'image':
      case 1:
        temp.type = 1
        break
      case 'video':
      case 2:
        temp.type = 2
        break
      default:
        temp.type = 2
    }
    // 处理时间 HH:mm:ss
    if (!isNull(temp.times) && !isUndefined(temp.times)) {
      if (!isNaN(Number(temp.times))) {
        temp.times = dayjs.utc(ceil(Number(temp.times)) * 1000).format('HH:mm:ss')
      }
    }
    return temp
  }, [item])

  // 播放器实例
  const playerRef = useRef(null)
  const clearMouseleaveTimeout = useRef(null)
  const clearShowVideoHandle = useRef(null)

  const [showCustomPoster, setShowCustomPoster] = useState(true)
  const [showVideo, setShowVideo] = useState(false)

  const cardUrl = useMemo(() => {
    // eslint-disable-next-line no-nested-ternary
    return formatItem.fileStatus === 1
      ? translateTxt('components:image.t1')
      : formatItem.previewUrl
  }, [formatItem])
  const setPlayerIns = useCallback(player => (playerRef.current = player), [playerRef.current])

  const playAnchorElement = useMemo(() => {
    return playAnchor()
  }, [playAnchor])

  const mouseenter = e => {
    if (clearMouseleaveTimeout.current) {
      clearTimeout(clearMouseleaveTimeout.current)
    }
    clearShowVideoHandle.current = setTimeout(() => {
      // 悬浮播放回调，用于埋点
      hoverPlayCallback && hoverPlayCallback()
      const player = playerRef.current
      // 移除自定义海报
      setShowCustomPoster(false)
      if (player) {
        // player.currentTime(0);
        player.play().catch(() => {})
      } else {
        // 初始化video
        setShowVideo(true)
      }
      clearShowVideoHandle.current = null
    }, 800)
  }

  const mouseleave = e => {
    // 显示自定义海报
    setShowCustomPoster(true)
    if (clearShowVideoHandle.current) {
      clearTimeout(clearShowVideoHandle.current)
    }
    if (clearMouseleaveTimeout.current) {
      clearTimeout(clearMouseleaveTimeout.current)
    }
    clearMouseleaveTimeout.current = setTimeout(() => {
      const player = playerRef.current
      // 判断video是否全屏，如果处于全屏状态下，则无需销毁
      if (player && player.isFullscreen()) {
        return
      }
      setShowVideo(false)
    }, 300)
  }

  const handleImageLoaded = () => {
    setLoaded(true)
    setTimeout(() => {
      if (maskRef.current) {
        maskRef.current.style.display = 'none'
      }
    }, 150)
  }

  return (
    <div
      className={classnames(styles['media-box'], classNameWrap)}
      ref={dom => {
        square && setHeight(dom)
      }}
      onClick={() => {
        formatItem.status !== 1 &&
          (formatItem.type === 1 || !hoverAutoDisplay) &&
          handlePreview(formatItem)
      }}
      style={{
        cursor: formatItem.status === 1 ? 'default' : 'pointer',
      }}
    >
      {playAnchorElement &&
        React.cloneElement(playAnchorElement, {
          className: showVideo
            ? `${playAnchorElement.props.className} playing`
            : playAnchorElement.props.className,
          onMouseEnter: hoverAutoDisplay ? mouseenter : noop,
          onMouseLeave: hoverAutoDisplay ? mouseleave : noop,
        })}
      {/* 文件类型type 1图片 2视频 */}
      {formatItem.type === 2 && formatItem.fileStatus !== 1 ? (
        <div
          style={{ width: '100%', height: '100%', position: 'relative' }}
          onMouseEnter={hoverAutoDisplay && formatItem.url && !playAnchor() ? mouseenter : noop}
          onMouseLeave={hoverAutoDisplay && formatItem.url && !playAnchor() ? mouseleave : noop}
        >
          <div
            ref={maskRef}
            style={{
              position: 'absolute',
              background: '#1F2122',
              width: '100%',
              height: '100%',
              left: 0,
              top: 0,
              zIndex: 1000,
              opacity: !loaded ? 1 : 0,
              transition: 'all 0.15s',
            }}
          />
          {showCustomPoster && !showVideo && (
            <div className="cb-lazy-load-wrapper">
              <div
                className="fuzzy-bg"
                style={{
                  backgroundImage: showBgImageUrl ? `url(${cardUrl})` : '',
                }}
              />
              {showBgImage && (
                <img
                  className="fuzzy-bg"
                  // @ts-ignore
                  src={cardUrl}
                  alt=""
                />
              )}
              <img
                className="media-box-img"
                // @ts-ignore
                src={cardUrl}
                alt=""
                onLoad={handleImageLoaded}
                onError={handleImageLoaded}
              />
              {playIconVisible && (
                <React.Fragment>
                  {formatItem.url ? (
                    <IconSvg className="icon-bofang" type="iconbofang2" style={{ zIndex: 2 }} />
                  ) : (
                    <span
                      style={{
                        color: '#fff',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                      }}
                    >
                      {translateTxt?.('inspiration:t47')}
                    </span>
                  )}
                </React.Fragment>
              )}
              <span className="total-time">{formatItem.times}</span>
            </div>
          )}
          {showVideo && (
            <CBVideo
              rotatePlayer={false}
              // @ts-ignore
              setPlayerIns={setPlayerIns}
              wrappedStyle={{ width: '100%', height: '100%', position: 'relative', zIndex: 2 }}
              // @ts-ignore
              src={formatItem.url}
              config={{
                controlBar: false,
                autoplay: true,
                muted: true,
              }}
            />
          )}
        </div>
      ) : scrollContainer && !isServer() ? (
        <div />
      ) : (
        <div className="cb-lazy-load-wrapper">
          {showBgImage && (
            <div
              className="fuzzy-bg"
              style={{
                backgroundImage: `url(${cardUrl})`,
              }}
            />
          )}
          <img
            className="media-box-img"
            // @ts-ignore
            src={cardUrl}
            onLoad={handleImageLoaded}
            onError={handleImageLoaded}
            alt=""
          />
        </div>
      )}
    </div>
  )
})

export default MediaBox
